module.exports = __webpack_public_path__ + "media/images/attachement-preview-02-1d1a781516a628fb6b22c0cce0fa01d4.jpg";